import { useNavigate } from 'react-router-dom';

const partLinks = [
  { label: 'Vertical Blind Parts', href: '/category/vertical-blind-parts' },
  { label: 'Horizontal Blind Parts', href: '/category/horizontal-blind-parts' },
  { label: 'Mini Blind Parts', href: '/category/mini-blind-parts' },
  { label: 'Valance Clips', href: '/category/valance-clips' },
  { label: 'Mounting Brackets', href: '/category/mounting-brackets' },
  { label: 'Chains & Cords', href: '/category/chains-cords' },
  { label: 'Drapery Hardware', href: '/category/drapery-hardware' },
];

const companyLinks = [
  { label: 'About Us', href: '/about' },
  { label: 'Shipping Policy', href: '/about' },
  { label: 'Return Policy', href: '/about' },
  { label: 'Contact Us', href: '/about' },
];

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-stone-950 text-stone-400">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <button onClick={() => navigate('/')} className="flex items-center gap-2.5 mb-5 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-amber-600 rounded-sm flex-shrink-0">
                <i className="ri-home-gear-line text-white text-base" />
              </div>
              <div>
                <span className="font-bold text-white text-sm tracking-wider block">BLINDS USA INC</span>
                <span className="text-amber-500 text-[9px] tracking-widest uppercase">Parts &amp; Hardware Store</span>
              </div>
            </button>
            <p className="text-sm leading-relaxed mb-5">
              Your source for blind replacement parts and window hardware since 1997. Over 1,000 parts in stock. Nationwide fast shipping.
            </p>
            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2.5">
                <i className="ri-phone-line text-amber-500" />
                <a href="tel:+18005551234" className="hover:text-amber-400 transition-colors">1-800-555-1234</a>
              </div>
              <div className="flex items-center gap-2.5">
                <i className="ri-mail-line text-amber-500" />
                <a href="mailto:parts@blindsusainc.com" className="hover:text-amber-400 transition-colors">parts@blindsusainc.com</a>
              </div>
              <div className="flex items-center gap-2.5">
                <i className="ri-time-line text-amber-500" />
                <span>Mon–Fri 8AM–6PM EST</span>
              </div>
            </div>
          </div>

          {/* Parts Categories */}
          <div>
            <h3 className="text-white font-bold text-sm tracking-wider uppercase mb-5">Parts Catalog</h3>
            <ul className="space-y-2.5">
              {partLinks.map((l) => (
                <li key={l.label}>
                  <button
                    onClick={() => navigate(l.href)}
                    className="text-sm hover:text-amber-400 transition-colors cursor-pointer text-left"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-bold text-sm tracking-wider uppercase mb-5">Company</h3>
            <ul className="space-y-2.5">
              {companyLinks.map((l) => (
                <li key={l.label}>
                  <button
                    onClick={() => navigate(l.href)}
                    className="text-sm hover:text-amber-400 transition-colors cursor-pointer text-left"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Why Us */}
          <div>
            <h3 className="text-white font-bold text-sm tracking-wider uppercase mb-5">Why Shop With Us</h3>
            <ul className="space-y-3">
              {[
                { icon: 'ri-truck-line', text: 'Free Shipping on $49+' },
                { icon: 'ri-database-2-line', text: '1,000+ Parts In Stock' },
                { icon: 'ri-calendar-check-line', text: 'In Business Since 1997' },
                { icon: 'ri-shield-check-line', text: '30-Day Easy Returns' },
                { icon: 'ri-time-line', text: 'Ships in 1–2 Business Days' },
              ].map((item) => (
                <li key={item.text} className="flex items-center gap-2.5 text-sm">
                  <i className={`${item.icon} text-amber-500`} />
                  <span>{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-stone-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-stone-600">
          <span>&copy; {new Date().getFullYear()} Blinds USA Inc. All rights reserved.</span>
          <span>Blind parts, window hardware &amp; replacement components — nationwide shipping since 1997</span>
        </div>
      </div>
    </footer>
  );
}
